var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleSidebar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9918 10.217C15.3528 10.217 17.2668 8.30301 17.2668 5.942C17.2668 3.58098 15.3528 1.66699 12.9918 1.66699C10.6308 1.66699 8.7168 3.58098 8.7168 5.942C8.7168 8.30301 10.6308 10.217 12.9918 10.217Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29908 16.1997C6.71661 16.1997 7.86576 15.0506 7.86576 13.6331C7.86576 12.2155 6.71661 11.0664 5.29908 11.0664C3.88155 11.0664 2.73242 12.2155 2.73242 13.6331C2.73242 15.0506 3.88155 16.1997 5.29908 16.1997Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8501 18.3331C15.0283 18.3331 15.9835 17.3779 15.9835 16.1997C15.9835 15.0215 15.0283 14.0664 13.8501 14.0664C12.6719 14.0664 11.7168 15.0215 11.7168 16.1997C11.7168 17.3779 12.6719 18.3331 13.8501 18.3331Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleSidebar);
export default __webpack_public_path__ + "static/media/bubble-sidebar.05ed1a990358d4c8ae08f81c5497b3ce.svg";
export { ForwardRef as ReactComponent };